import { useContext, useRef } from "react";
import { StateContext } from "../context/StateContext";
import { ResponseData } from "../types/ReponseData";

const SERVER_NAME =
  process.env.REACT_APP_AS_URL || "https://activation.rossvideo.cloud";
const API_PATH = "activation/Activation/Service/Offline";
const ACTIVATE = "Activate.js";
const DEACTIVATE = "Deactivate.js";

export const useRequest = () => {
  const state = useContext(StateContext);

  const { status, requestParameters } = state.currentState;

  const isRequestInProgress = useRef(false);
  if (status === "request-in-progress") {
    if (!isRequestInProgress.current && requestParameters) {
      isRequestInProgress.current = true;
      const encryptedPayload = requestParameters.encryptedPayload;
      const pk = requestParameters.productKey;
      const generatedBy = requestParameters.generatedBy;

      const action =
        requestParameters.requestType === "activation" ? ACTIVATE : DEACTIVATE;
      fetch(
        `${SERVER_NAME}/${API_PATH}/${action}?productKeyCode=${pk}&generatedBy=${generatedBy}`,
        {
          method: "POST",
          body: Uint8Array.from(atob(encryptedPayload), (c) => c.charCodeAt(0)),
        },
      )
        .then((data) => data.json())
        .then((data) => {
          isRequestInProgress.current = false;
          const response: ResponseData = {
            responseType: requestParameters.requestType,
            serverResponse: data,
            productType: requestParameters.productName,
            generatedBy: requestParameters.generatedBy,
          };
          state.updateState({
            ...state.currentState,
            status: "request-complete",
            responseData: response,
          });
        });
    }
  }
};
